import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

export const StyledParagraphNormal = styled.p`
  color: #414042;
  font-size: 22px;
`
export const StyledParagraphSmall = styled.p`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2em;
  line-height: 1.3;

  color: #414042;

  ${breakpoint.sm} {
    font-size: 1.15em;
  }

  ${breakpoint.md} {
    font-size: 1.2em;
  }
`

export const StyledCeoQuote = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1.2em;
  /* line-height: 42px; */
  /* or 117% */

  color: #414042;

  ${breakpoint.md} {
    font-size: 1.2em;
  }
`

export const StyledBigHeaderH2 = styled.h2`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 3.2em;
  line-height: 1;
  text-transform: uppercase;
  color: #0f6497;
  margin: 0;

  ${breakpoint.md} {
    font-size: 3.8em;
  }

  ${breakpoint.lg} {
    font-size: 4.2em;
  }
`

export const StyledProfileDetails = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1em;
  /* line-height: 34px; */
  /* or 121% */

  color: #0f6497;
`
export const KeyHighlightsHeader = styled.h3`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.4em;
  line-height: 1;
  /* line-height: 100px; */
  /* or 139% */

  text-transform: uppercase;

  color: #414042;
  margin: 0px;

  ${breakpoint.md} {
    font-size: 2.4em;
  }
  ${breakpoint.lg} {
    font-size: 3em;
  }
`

export const KeyHighlightsNumbers = styled.div`
  font-family: "Lato", georgia, serif;
  font-size: 3.6em;
  font-style: normal;
  font-weight: 800;
  line-height: 1;
  color: #0f6497;

  ${breakpoint.md} {
    font-size: 4.4em;
  }
  ${breakpoint.lg} {
    font-size: 6em;
  }
`
export const KeyHighlightsText = styled.div`
  font-family: "Lato", georgia, serif;
  font-size: 1.1em;
  font-style: normal;
  font-weight: 500;
  /* line-height: 43px; */

  ${breakpoint.md} {
    font-size: 1.3em;
  }
  ${breakpoint.lg} {
    font-size: 1.5em;
  }
`

export const StyledTestimonialText = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 2.2em;
  line-height: 1.05;
  /* line-height: 70px; */
  /* or 109% */
  text-align: left;

  ${breakpoint.md} {
    font-size: 2.35em;
  }
  ${breakpoint.lg} {
    font-size: 2.5em;
    text-align: center;
  }
  ${breakpoint.xl} {
    font-size: 2.8em;
    text-align: center;
  }

  color: #0f6497;
`
export const StyledTestimonialSignOff = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 800;
  font-size: 1.05em;
  line-height: 1;
  /* line-height: 34px; */
  /* or 121% */

  text-align: left;

  ${breakpoint.md} {
    font-size: 1.15em;
  }
  ${breakpoint.lg} {
    font-size: 1.3em;
    text-align: center;
  }

  color: #3b3f43;
`

export const StyledCaseStudiesSubtitleText = styled.div`
  font-family: "Lato", georgia, serif;
  font-style: normal;
  font-weight: 500;
  font-size: 26px;
  line-height: 30px;
  /* or 115% */

  color: #414042;
`

export const StyledClickToDownload = styled.div`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.05em;
  line-height: 1.05;
  /* or 106% */

  text-transform: uppercase;

  color: #ffffff;

  ${breakpoint.sm} {
    font-size: 1.45em;
  }

  ${breakpoint.md} {
    font-size: 1.8em;
  }

  ${breakpoint.lg} {
    font-size: 3em;
  }
`

export const StyledClickToDownloadMedium = styled.div`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5em;
  line-height: 1.3;
  /* or 106% */

  text-transform: uppercase;

  color: #ffffff;

  ${breakpoint.sm} {
    font-size: 1.65em;
  }
  ${breakpoint.md} {
    font-size: 1.85em;
  }

  ${breakpoint.lg} {
    font-size: 2.6em;
  }
`
export const StyledClickToDownloadBig = styled.div`
  font-family: "Open Sans", georgia, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 2.1em;
  line-height: 1.3;
  /* or 106% */

  text-transform: uppercase;

  color: #ffffff;

  ${breakpoint.sm} {
    font-size: 2.5em;
  }
  ${breakpoint.md} {
    font-size: 2em;
  }

  ${breakpoint.lg} {
    font-size: 3.3em;
  }
`

export const StyledImpactApproachTitle = styled.h3`
  font-family: Lato;
  font-style: normal;
  font-weight: 800;
  font-size: 1.6em;

  text-transform: uppercase;

  color: #0f6497;
  margin: 0;

  ${breakpoint.lg} {
    font-size: 1.9em;
  }
`
export const StyledImpactApproachContent = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1.2em;

  color: #0f6497;
  margin: 0;

  ${breakpoint.lg} {
    font-size: 1.3em;
  }
`

export const StyledDownloadAnchor = styled.a`
  color: #ffffff;
  cursor: pointer;

  &:visited {
    color: #ffffff;
  }

  &:active,
  &:hover {
    color: #cecece;
  }
`
